<div class="file-upload-box">
  <mat-accordion class="upload-accordion">
    <mat-expansion-panel #uploadPanel  [expanded]="true" class="upload-panel">
      <mat-expansion-panel-header class="upload-title-container">
        <mat-panel-title>
          <div class="upload-title">
            <span class="upload-title__icon"><mat-icon>upload_file</mat-icon></span>
            <span class="upload-title__copy"><strong>Uploads</strong><small>{{getFilesCount()}} file{{getFilesCount() === 1 ? '' : 's'}} in progress</small></span>
          </div>
        </mat-panel-title>
        <mat-panel-description class="upload-header-actions">
          <span class="upload-count">{{getFilesCount()}}</span>
          <button mat-icon-button (click)="closeUploadPanelAll()" matTooltip="Close All" class="close-btn">
            <mat-icon>close</mat-icon>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="file-list-container">
        @for (file of getFiles(); track file) {
          <div class="file-entry">
            <div class="file-row" [ngClass]="{'failed': file.uploadFailed}">
              <span class="file-icon-wrap"><img [src]="getFileFormatIcon(file)" alt="" width="22" class="file-icon" /></span>
              <div class="file-info">
                <div class="file-title-row">
                  <span class="file-title text-truncate" [ngClass]="{'text-danger': file.uploadFailed}">
                    {{file.title}}.{{file.file_format}}
                  </span>
                  <span class="file-size">{{file.file_size | fileSize}}</span>
                </div>
                <mat-progress-bar
                  [value]="file.progress"
                  class="fileupload-progress"
                  [color]="file.uploadFailed ? 'warn' : 'primary'">
                </mat-progress-bar>
              </div>
              <div class="file-actions">
                @if (file.uploading && !file.uploadFailed) {
                  <span class="progress-percent">{{file.progress}}%</span>
                }
                @if (file.uploadFailed) {
                  <button mat-icon-button (click)="retryUpload(file)" matTooltip="Retry">
                    <mat-icon color="warn">refresh</mat-icon>
                  </button>
                  <button mat-icon-button (click)="closeUploadPanel(file)" matTooltip="Remove file">
                    <mat-icon color="warn">delete</mat-icon>
                  </button>
                }
                @if (!file.uploadFailed) {
                  <button mat-icon-button (click)="closeUploadPanel(file)" matTooltip="Cancel upload">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </div>
            </div>
            @if (file.uploadFailed) {
              <div class="error-message text-danger">
                {{file.uploadFailedMessage || 'Upload failed'}}
              </div>
            }
            <hr class="divider" />
          </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
